// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"328":"admin","343":"onboarding","674":"iso","710":"merchant","983":"payments"}[chunkId] + "." + {"328":"8f36daaf","343":"6cbe3506","674":"bde0e47c","710":"19acdacd","983":"5ff493e3"}[chunkId] + ".css";
};